
import { useState, useEffect } from 'react';

interface UseLoadGoogleMapsScriptReturn {
  isLoaded: boolean;
  isLoadingScript: boolean;
  error: string | null;
  loadScript: (apiKey: string) => void;
}

export const useLoadGoogleMapsScript = (): UseLoadGoogleMapsScriptReturn => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoadingScript, setIsLoadingScript] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadScript = (apiKey: string) => {
    if (!apiKey) {
      setError('API key is required');
      return;
    }

    setIsLoadingScript(true);
    setError(null);
    
    // Remove old script if it exists
    const existingScript = document.getElementById('google-maps-script');
    if (existingScript) {
      existingScript.remove();
    }
    
    // Create new script element
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.id = 'google-maps-script';

    script.onload = () => {
      setIsLoaded(true);
      setIsLoadingScript(false);
    };

    script.onerror = () => {
      setError('Failed to load Google Maps API');
      setIsLoadingScript(false);
    };

    document.head.appendChild(script);
  };

  return {
    isLoaded,
    isLoadingScript,
    error,
    loadScript
  };
};
